export default {"src":"/_next/static/media/migrate.a32bc38e.svg","height":68,"width":75};